<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import url('./assets/sass/newCommon.scss');
@import url('./assets/sass/flex.css');
html,
body {
  position: relative;
  height: 100%;
}
body{
}
@keyframes moduleBegin {
    from {top: 50px; opacity: 0;}
    to {top: 0; opacity: 1;}
}
</style>



// WEBPACK FOOTER //
// src/App.vue